const API = "https://jm.komerzy.com/backend/routes/api.php?url=cotizacionapi";

// Función para obtener token desde localStorage
const getToken = () => localStorage.getItem("token");

// ==========================
// LISTAR COTIZACIONES
// ==========================

export const getCotizaciones = async () => {
    const token = getToken();

    const response = await fetch(`${API}&action=listar`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const data = await response.json();
    return data.data;
};

// ==========================
// REGISTRAR COTIZACION
// ==========================

export const guardarCotizacion = async (cotizacion) => {
    const token = getToken();

    const response = await fetch(`${API}&action=registrar`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(cotizacion),
    });

    return await response.json();
};

// ==========================
// VER DETALLE COTIZACION
// ==========================

export const getDetalleCotizacion = async (idcotizacion) => {
    const token = getToken();

    const response = await fetch(`${API}&action=detalle`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ idcotizacion }),
    });

    const data = await response.json();
    return data.data;
};